import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }

import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";
import PM02PM03Chart from "@/components/metrics/PM02PM03Chart.vue";
import ReliabilityMetricsLinkTable from "../links/ReliabilityMetricsLinkTable.vue";
import WorkManagementMetricsLinkTable from "../links/WorkManagementMetricsLinkTable.vue";
import { Deleteable } from "@/classes/asset-management-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceLevelsKPIs',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.work_management_metrics,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.work_management_metrics) = $event)),
      label: "6.1 Work Management Metrics",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(WorkManagementMetricsLinkTable, {
      class: "mb-4",
      readonly: _ctx.readonly,
      onDelete: _cache[1] || (_cache[1] = ($event: any) => (emit('delete', $event)))
    }, null, 8, ["readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.reliability_metrics,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).plan.reliability_metrics) = $event)),
      label: "6.2 Reliability Metrics",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(ReliabilityMetricsLinkTable, {
      class: "mb-4",
      readonly: _ctx.readonly,
      onDelete: _cache[3] || (_cache[3] = ($event: any) => (emit('delete', $event)))
    }, null, 8, ["readonly"]),
    _createVNode(_component_v_card, {
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("6.3 PM02/PM03")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(PM02PM03Chart, {
          class: "pa-3",
          "hide-title": "",
          "chart-height": "500px",
          "floc-ids": 
          _unref(store).plan.floc_boundaries.map((b) => b.functional_location_id)
        
        }, null, 8, ["floc-ids"])
      ]),
      _: 1
    })
  ]))
}
}

})